import { OnInit, OnDestroy } from "@angular/core";
var OffsidebarComponent = /** @class */ (function () {
    function OffsidebarComponent(settings, themes, translator) {
        this.settings = settings;
        this.themes = themes;
        this.translator = translator;
        this.clickEvent = "click.offsidebar";
        this.$doc = null;
        this.currentTheme = themes.getDefaultTheme();
        this.selectedLanguage = this.getLangs()[0].code;
    }
    OffsidebarComponent.prototype.ngOnInit = function () {
        this.anyClickClose();
    };
    OffsidebarComponent.prototype.setTheme = function () {
        this.themes.setTheme(this.currentTheme);
    };
    OffsidebarComponent.prototype.getLangs = function () {
        return this.translator.getAvailableLanguages();
    };
    OffsidebarComponent.prototype.setLang = function (value) {
        this.translator.useLanguage(value);
    };
    OffsidebarComponent.prototype.anyClickClose = function () {
        var _this = this;
        this.$doc = $(document).on(this.clickEvent, function (e) {
            if (!$(e.target).parents(".offsidebar").length) {
                _this.settings.layout.offsidebarOpen = false;
            }
        });
    };
    OffsidebarComponent.prototype.ngOnDestroy = function () {
        if (this.$doc)
            this.$doc.off(this.clickEvent);
    };
    return OffsidebarComponent;
}());
export { OffsidebarComponent };
